'use client';
import { useCallback, useState } from 'react';

import { localStorageAvailable } from '../local-storage-available';
import { storage } from '../storage';

export function useStorage<T>(key: string) {
  const storageAvailable = localStorageAvailable();

  const [state, setState] = useState<T | null>(() => {
    if (!storageAvailable) return null;

    const storedValue = storage.get<T>(key);

    // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing
    return storedValue ? storedValue : null;
  });

  const set = useCallback(
    (value: T | null) => {
      if (!storageAvailable) return;

      if (value === null) {
        storage.remove(key);
        setState(null);
      } else {
        storage.set(key, JSON.stringify(value));
        setState(value);
      }
    },
    [key]
  );

  return [state, set] as [T | undefined, (value: T | null) => void];
}
